import { Component, OnInit } from "@angular/core"

import { SessionService } from "src/app/services/session.service"
import { toastrService } from "src/app/services/ux/toastr.service"
import { Loan, LoanService } from "src/app/services/loan.service"
import { LocaleConverterService } from "src/app/common/helpers/locale-converter.service";
import { SetTitleService } from "src/app/services/set-title.service";

@Component({
  templateUrl: "./loan.component.html",
  styleUrls: ["./loan.component.css"]
})

export class LoanComponent implements OnInit {
  loans: Loan[] = []
  openingLoanIndexes: number[] = []
  loading: boolean = false

  constructor(
    public toastr: toastrService,
    private session: SessionService,
    private loanService: LoanService,
    private converter: LocaleConverterService,
    private settitleservice : SetTitleService
  ) {}

  ngOnInit() {
    this.getLoans();
    this.settitleservice.sendTitle("Loans");
  }

  async getLoans() {
    if (!this.session.isLoggedIn()) return
    
    this.loading = true
    await this.loanService.getLoans()
    this.loading = false

    this.loanService.loans.subscribe(data => this.loans = data)
  }

  toggleLoan(index: number) {
    if (this.isOpen(index)) {
      this.openingLoanIndexes = this.openingLoanIndexes.filter(number => number !== index)
      return
    }

    this.openingLoanIndexes = this.openingLoanIndexes.concat(index)
  }

  isOpen(index: number) {
    return this.openingLoanIndexes.includes(index)
  }
}